if (!customElements.get('cs-mm-recommendations')) {
  customElements.define('cs-mm-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', event => {
        const opener = event.target.closest('[data-mm-open]');
        if (opener) {
          const dialog = document.getElementById(opener.dataset.mmOpen);
          if (!dialog?.showModal) return;
          event.preventDefault();
          this.opener = opener;
          dialog.querySelector('[data-mm-error]').hidden = true;
          dialog.showModal();
        }
        const close = event.target.closest('[data-mm-close]');
        if (close) close.closest('dialog').close();
        const add = event.target.closest('[data-mm-add]');
        if (add) this.addItem(add.closest('dialog'));
        if (event.target.matches('dialog')) {
          const rect = event.target.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
        }
      });
      this.addEventListener('change', event => {
        const select = event.target.closest('[data-mm-variant]');
        if (!select) return;
        const option = select.selectedOptions[0];
        const dialog = select.closest('dialog');
        dialog.querySelector('[data-mm-error]').hidden = true;
        if (!option?.value) return;
        dialog.querySelector('[data-mm-price]').textContent = option.dataset.price;
        const compare = dialog.querySelector('[data-mm-compare]');
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
      });
      this.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('close', () => this.opener?.focus()));
    }
    async addItem(dialog) {
      if (this.busy || this.dataset.demo === 'true') return;
      const select = dialog.querySelector('[data-mm-variant]');
      const option = select.selectedOptions[0];
      const error = dialog.querySelector('[data-mm-error]');
      if (!option?.value || option.disabled) {
        error.textContent = error.dataset.choice;
        error.hidden = false;
        select.focus();
        return;
      }
      this.busy = true;
      const button = dialog.querySelector('[data-mm-add]');
      button.disabled = true;
      button.textContent = button.dataset.loading;
      dialog.setAttribute('aria-busy', 'true');
      error.hidden = true;
      const productForm = document.getElementById(this.dataset.formId)?.closest('product-form');
      const sections = productForm?.getSectionsToRender?.().map(section => section.section) || ['cart-drawer', 'cart-bubble'];
      const root = (this.dataset.rootUrl || '/').replace(/\/?$/, '/');
      let added = false;
      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST', credentials: 'same-origin',
          headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({items: [{id: Number(option.value), quantity: 1}], sections, sections_url: window.location.pathname})
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : error.dataset.error);
        added = true;
        dialog.close();
        if (typeof productForm?.renderContents === 'function' && result.sections?.['cart-drawer']) {
          productForm.renderContents(result);
          document.dispatchEvent(new CustomEvent('cart:item-added', {bubbles: true, detail: {product: result.items?.[0], items: result.items}}));
        } else window.location.assign(this.dataset.cartUrl);
      } catch (failure) {
        if (added) window.location.assign(this.dataset.cartUrl);
        else {
          error.textContent = failure.message || error.dataset.error;
          error.hidden = false;
        }
      } finally {
        this.busy = false;
        button.disabled = false;
        button.textContent = button.dataset.idle;
        dialog.setAttribute('aria-busy', 'false');
      }
    }
  });
}
